import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Translatable} from "../../../../../Translatable";
import {DataTableDirective} from "angular-datatables";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {limit_T1, sous_module, tarif} from "../../../../model/db";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {environment} from "../../../../../../environments/environment";
import * as $ from "jquery";
import {valuesys} from "../../../../../../options";
import Swal from "sweetalert2";

@Component({
  selector: 'app-limit-t1',
  templateUrl: './limit-t1.component.html',
  styleUrls: ['./limit-t1.component.css']
})
export class LimitT1Component extends Translatable  implements  OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  title:string ;
  dtOptions: DataTables.Settings = {};
  modalRef: BsModalRef;
  titleModal:string ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  public limits_T1 :limit_T1[] = [] ;
  public limit_T1:limit_T1 = new limit_T1();
  public tarifs:tarif [] = [];
  public activite: string;
  public activiteSelected:string;
  public selectedIDTarif: number;

  public limit_T1_error : limit_T1 ;

  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private httpClient: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService,
              private route: Router
  ) {
    super();
  }

  async ngOnInit() {
    this.auth.initAutority("LIMT");
    this.initDatatable()
  }

  initDatatable(){
    this.isAdd = true ;
    this.isValid = false ;
    this.title = this.__("label_limit_T1");
    this.dtOptions = this.helper.dataTableOption();
    this.dtOptions.columns = [
      {
        searchable: true
      },
      {},
      {},
      {},
      
    ];
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.http
        .get<DataTablesResponse>(
          environment.limit_T1+"?child=tarif&" + $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
        ).subscribe(resp => {
        this.limits_T1 = resp.data;
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }

  async toggleState(limit_T1:limit_T1,state:number,btn:any){

    btn.disabled = true;
    let toogle = await this.http.get<any>(environment.limit_T1+`/${limit_T1.id}/${state}/state`,valuesys.httpAuthOptions()).toPromise();
    if(toogle.code == 201){
      this.toastr.success(toogle.msg,this.__("msg.success"));
      limit_T1.state = toogle.data.state

    }else {
      this.toastr.error(toogle.msg,this.__("msg.error"));
    }
    btn.disabled = false;
  }

  delete(delatelimit:limit_T1,elm){
    elm.disabled = true
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed_delete'),
      cancelButtonText: this.__('msg.cancel_delete')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.delete<any>(environment.limit_T1+"/" + delatelimit.id,valuesys.httpAuthOptions()).toPromise();
        // this.rerender();
        if(sup.code == 204){
          this.limits_T1= this.limits_T1.filter(function (item,index) {
            return item.id != delatelimit.id
          })
          Swal.fire(
            this.__('msg.deleted'),
            sup.msg,
            'success'
          )
        }else {
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
        elm.disabled = false

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        elm.disabled = false
        Swal.fire(
          this.__('msg.canceled'),
          this.__('msg.canceled_delete'),
          'error'
        )
      }
    })
  }


  async openModal(template:TemplateRef<any>,currenlimit:limit_T1 =null,elem) {
    console.log(currenlimit,"xxxx")
    this.limit_T1_error = new limit_T1()
    elem.disabled = true ;
    //this.tarifs = await this.helper.getSelectList(environment.tarif,['value']);
    if(currenlimit == null){
      this.isAdd = true ;
      this.limit_T1 = new limit_T1() ;
      this.titleModal = this.__('limit_T1.add') ;
    }else {

      this.isAdd = false ;
      this.titleModal = this.__('limit_T1.edit') ;
      this.limit_T1 = currenlimit ;
      //console.log(this.limit_T1);
      if (currenlimit.tarif != null) {
        this.selectedIDTarif = currenlimit.tarif_id;
        this.activiteSelected=currenlimit.tarif.activite;
       // console.log(" this.selectedIDTarif", this.selectedIDTarif)
        this.onChangeActivite();

      } else {
        this.tarifs = null;
      }

    }
    elem.disabled = false ;
    this.modalRef = this.modalService.show(template,{class:"modal-md",ignoreBackdropClick:true});

  }
  close(){
    this.modalRef.hide()
    this.isValid = false ;
    this.limit_T1 = new limit_T1();
    this.titleModal = this.__('sousmodule.edit') ;
    this.limit_T1_error = new limit_T1();
  }

  async addUserForm(){
    this.limit_T1_error = new limit_T1();
    this.isValid = true ;
    if(this.isAdd ){
      let res:any =  await this.http.post<any>(environment.limit_T1,this.limit_T1,valuesys.httpAuthOptions()).toPromise();
      console.log("res",res)
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
        res.data.tarif = this.tarifs.find( _ => _.id == this.limit_T1.tarif_id) ;
        this.limits_T1.push( res.data);
        this.close()
      }else if(res.code === 400){
        for (let item in res.data){
          this.limit_T1_error[item] = res.data[item][0] ;
        }
        this.limit_T1_error = <limit_T1> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }else {
      let res =  await this.http.put<any>( environment.limit_T1 + '/'+this.limit_T1.id,this.limit_T1,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.limit_T1.tarif = this.tarifs.find((_) =>_.id == this.limit_T1.tarif_id);
        this.toastr.success(res.msg,this.__("msg.success")) ;
        this.close()
      }else if(res.code === 400){
        this.limit_T1_error = <limit_T1> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }
    this.isValid = false ;


  }


  async onChangeActivite() {
    let res_tarifs= await this.helper.getSelectList( environment.tarif + `?where=activite|e|${this.activiteSelected}`, ['value']);
    // console.log('regions: ', this.tarifs);
    if (res_tarifs) {
      this.tarifs = res_tarifs;
      // console.log(' this.tarifschane activite: ', this.tarifs);

    }
  }


}
